import { atom, selector, useRecoilState } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

const layoutState = atom({
  key: 'layoutState',
  default: selector({
    key: 'layoutStateSelector',
    get: () => {
      return getCustomerSettings('layout');
    }
  })
});

export const useLayoutState = () => {
  const [layout, setLayout] = useRecoilState(layoutState);
  const isHorizontal = layout === 'horizontal';
  const isVertical = layout === 'vertical';
  const isMapOnly = layout === 'map-only';
  const isCrossOnly = layout === 'cross-only';

  const changeHorizontal = () => {
    setLayout('horizontal');
  };

  const changeVertical = () => {
    setLayout('vertical');
  };

  const changeMapOnly = () => {
    setLayout('map-only');
  };

  const changeCrossOnly = () => {
    setLayout('cross-only');
  }

  return {
    layout,
    isHorizontal,
    isVertical,
    isMapOnly,
    isCrossOnly,
    changeHorizontal,
    changeVertical,
    changeMapOnly,
    changeCrossOnly
  }
}